import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex: 1;

  background-color: var(--panel);
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #ccc;
`;

export const ProtocolsListing = styled.div`
  flex: 1;
  overflow: hidden;
  width: 450px;
  min-width: 450px;
  max-width: 450px;

  flex-direction: column;
  //background-color: var(--panel);
  border-right: 1px solid #ccc;

  padding: 5px;

  @media (max-width: 800px) {
    flex: 1;
    max-width: 100%;
    border-right: none;
    border-bottom: 1px solid #ccc;
  }
`;

export const VerticalScroll = styled.div`
  flex: 1 1 auto;
  height: 0px;
  flex-direction: column;

  width: 100%;

  overflow-y: auto;

  > h5 {
    height: 100%;
    vertical-align: middle;
    background-color: #000;
  }
`;

export const Header = styled.div`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const CTAButton = styled.div`
  font-weight: bold;
  border-radius: 25px;
  background-color: var(--primary);
  padding: 6px;
  flex: 0;

  align-items: center;

  color: white;

  cursor: pointer;

  align-items: center;

  > h4 {
    padding-left: 5px;
    padding-top: 0px;
    padding-bottom: 0px;
    font-size: small;
  }

  margin-left: 5px;

  :hover {
    opacity: 0.7;
  }

  color: white;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex: 1 1 0;
  text-transform: uppercase;
  flex-direction: column;
  justify-content: space-between;

  h1,
  h5 {
    min-width: 0; /* Garante que o elemento pode encolher */
    overflow: hidden; /* Esconde o texto que ultrapassa */
    text-overflow: ellipsis; /* Aplica o efeito de reticências */
    white-space: nowrap; /* Garante que o texto fique em uma linha */
    flex-shrink: 1; /* Garante que o texto pode encolher em um container flex */
  }

  h1 {
    font-size: 14px;
    font-weight: 800;
  }

  h5 {
    font-size: 13px;
    font-weight: 400;
    color: #aaa;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-block: 10px;
  width: 100%;
  padding-right: 5px;
`;

export const Avatar = styled.img<{ size?: number }>`
  height: ${(p) => p.size || 48}px;
  min-height: ${(p) => p.size || 48}px;
  aspect-ratio: 1;
  transition: height 0.25s;
  margin-right: 10px;
  border-radius: 50px;
`;

export const ProtocolContent = styled.div`
  flex: 1;
  flex-direction: column;

  padding: 5px;
  border-radius: 5px;
  width: 50vw;
  min-width: 300px;
  //background-color: #0001;
`;

export const HeaderButton = styled.button.attrs({
  className: "flex text-black bg-zinc-200 dark:text-white dark:bg-zinc-700",
})`
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;

  //border: dotted var(--primary) 1px;
  border-radius: 8px;
  height: 50px;

  cursor: pointer;

  :hover {
    opacity: 0.75;
  }

  :active {
    opacity: 0.5;
  }

  color: #444;

  p {
    font-weight: 600;
    text-transform: uppercase;

    font-size: 12px;
  }
`;
